module.exports = __webpack_public_path__ + "static/media/default_tatibana_shun_update3222eca076da045b2acc1a3df5726fee.webp";